export const AI_CHAT_AUTO_SCROLL_PAUSE_EVENT =
  'affine-ai-chat-auto-scroll-pause';

export const AI_CHAT_AUTO_SCROLL_RESUME_THRESHOLD = 32;

export const AI_CHAT_SCROLL_DOWN_INDICATOR_THRESHOLD = 200;
